// The deadline includes headers AND the complete response body.
export async function fetchJson<T>(url: string, init: RequestInit = {}, timeoutMs = 20_000, timeoutMessage = '请求超时，请稍后重试') {
  const controller = new AbortController()
  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    return await Promise.race([
      (async () => {
        const response = await fetch(url, { ...init, signal: controller.signal })
        if (!response.ok) {
          // Read the API's error message, also under the deadline.
          const body = await response.json().catch(() => null) as { error?: string } | null
          throw new Error(body?.error || `服务返回 HTTP ${response.status}`)
        }
        return await response.json() as T
      })(),
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => { reject(new Error(timeoutMessage)); controller.abort() }, timeoutMs)
      }),
    ])
  } finally { clearTimeout(timer) }
}
